/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'bot-management-match';
const prefix = `${moduleName}.${componentName}`;

export const classificationsLabel = `${prefix}.classificationsLabel`;
export const classificationLabel = `${prefix}.classificationLabel`;

export const ENGLISH = {
    [classificationsLabel]: 'Classifications ({0})',
    [classificationLabel]: 'Classification',
};
